import React, { useEffect, useMemo } from 'react';
import { useField } from 'react-final-form';
import { observer } from 'mobx-react';
import { DateField } from 'ksnm-common-ui/lib/Form/DateField';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { SelectField } from 'ksnm-common-ui/lib/Form/SelectField';

import { reportsStore } from '@stores/dictionaryStores/reports/reportsStore';
import { reportVersionEditStore } from '@stores/dictionaryStores/reportVersion/reportVersionEditStore';
import { reportVersionsStore } from '@stores/dictionaryStores/reportVersion/reportVersionsStore';

import styles from '../ReportVersionEdit.module.scss';

export const ReportVersionForm = observer(() => {
  const { isEditMode, setDisableEdit, isNew } = reportVersionEditStore;
  const { selectedKeys } = reportVersionsStore;
  const { reports } = reportsStore;

  const reportItems = useMemo(() => {
    const group = selectedKeys[0]?.split(' - ')[0]; // ключ вида reportGroupCode - reportTypeCode
    if (group) return reports.filter((item) => item.reportGroupCode === group);

    return reports;
  }, [reports, selectedKeys]);

  const {
    input: { value: regulated },
  } = useField('regulated');

  useEffect(() => {
    if (regulated) setDisableEdit();

    return () => setDisableEdit(false);
  }, [regulated, setDisableEdit]);

  return (
    <>
      <TextField
        name="code"
        label="Код версии отчетной формы"
        disabled
        size="small"
        groupStyle={!isEditMode}
        maxLength={34}
      />
      <SelectField
        items={reportItems}
        name="reportCode"
        label="Код отчета"
        disabled={!isNew}
        size="small"
        groupStyle={!isEditMode}
        required
        renderName={(value) => `${value.code} - ${value.name}`}
      />
      <TextField
        name="version"
        label="Номер версии"
        disabled={!isNew}
        size="small"
        groupStyle={!isEditMode}
        maxLength={3}
        required
      />
      <TextField
        name="name"
        label="Наименование версии отчетности"
        disabled={!isEditMode}
        size="small"
        groupStyle
        maxLength={1000}
        required
      />
      <TextField
        name="externalVersionCode"
        label="Ссылка на внешний код версии"
        disabled={!isEditMode}
        size="small"
        groupStyle
        maxLength={36}
      />
      <div className={styles.flexRow}>
        <DateField
          name="beginDate"
          label="Дата начала действия версии"
          disabled={!isEditMode}
          size="small"
          groupStyle
          className={styles.dateField}
          required
        />
        <DateField
          name="finishDate"
          label="Дата окончания действия версии"
          disabled={!isEditMode}
          size="small"
          groupStyle
          className={styles.dateField}
        />
      </div>
    </>
  );
});
